const getAuthHeader = () => {
  const userData = JSON.parse(localStorage.getItem("user_data"))
  return {
    Authorization: "Bearer " + userData.token.access_token
  }
}
const getAuthAndMultipartHeader = () => {
  const header = getAuthHeader()
  return header
}

export { getAuthHeader, getAuthAndMultipartHeader }
